import MetadataList from "@/browse/MetadataList.vue"
import apolloProvider from 'src/lib/graphql/vue-apollo'
import router from 'src/router/router'

export default {
    el: '#vue-container',
    apolloProvider,
    router,
    components: {
        MetadataList
    },
}
